import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import CardVacancy from '../../../CardVacancy';

import { Container, GridVacancies } from './styles';

function Section({ vacancy, params, company, query }) {
  const [showHide, setShowHide] = useState(true);

  return (
    <Container showHide={showHide}>
      <span className="title-section" onClick={() => setShowHide(old => !old)}>
        {vacancy.department}{' '}
        <FontAwesomeIcon icon={faAngleDown} style={{ width: '16px' }} />
      </span>
      {
        <GridVacancies showHide={showHide}>
          {vacancy.items.map((item, i) => (
            <CardVacancy
              key={`card${i}`}
              vacancy={item}
              query={query}
              params={params}
              primaryColor={company?.base_hexcolor}
            />
          ))}
        </GridVacancies>
      }
    </Container>
  );
}

export default Section;
